<template>
    <v-card>

        <v-card-title>
            Faça a atribuição do executivo que irá responder a esta cotação
        </v-card-title>
        <v-card-text>
            <div class="--radio-boxes">
                <v-radio-group v-model="executiveId">
                    <v-radio v-for="user in users" :key="user.id"
                        :value="user.id">
                    <template v-slot:label>
                        <div class="--radio-label">
                            <strong>{{user.name}}</strong>
                            <span>{{user.email}}</span>
                            <span>{{user.contacts.length ? user.contacts[0]?.contact : ''}}</span>
                        </div>
                    </template>
                </v-radio>
                </v-radio-group>
                <div class="v-radio -success mt-n5" @click="openAddUserDialog" style="cursor: pointer;">
                    <div class="pr-3"><v-icon color="success">mdi-plus-circle-outline</v-icon></div>
                    <strong>
                        Adicionar novo usuário
                    </strong>
                </div>
            </div>
            <div class="d-flex pt-3">
                <v-spacer></v-spacer>
                <v-btn text @click="cancel()" class="mx-1">Cancelar</v-btn>
                <v-btn color="primary" class="mr-1" elevation="0" @click="send()" :disabled="!executiveId || preventExecutiveId == executiveId" :loading="processing">Confirmar
                    atribuição</v-btn>
            </div>
        </v-card-text>
        
        <AddUserDialog 
            :isAddUser.sync="isAddUserDialog"
            @userCreated="onUserCreated" />
    </v-card>
</template>
<script>
import AddUserDialog from '@/components/management/AddUserDialog.vue'
import { showSuccess, showError } from '@/plugins/snackbar-helper'

export default {
    components: {
        AddUserDialog
    },
    data: () => ({
        preventExecutiveId: null,
        processing: false,
        executiveId: null,
        isAddUserDialog: false
    }),
    props: {
        users: Array
    },
    mounted(){
        const executive = this.users.find((user) => user.isExecutiveFromGrid)
        console.log('executive', executive)
        this.preventExecutiveId = executive.id
        this.executiveId = executive.id
    },
    methods: {
        openAddUserDialog() {
            this.isAddUserDialog = true
        },
        onUserCreated() {
            this.$emit('user-created')
        },
        cancel() {
            this.$emit('close-dialog', false)
        },
        send() {
            this.processing = true
            const form = {
                userId: this.executiveId,
                sourceId: 'grid',
                reference: this.$route.params.gridId
            }

            this.$axios.post(`executive-publisher/create`, form).then((data) => {
                this.processing = false
                showSuccess('Executivo atribuído com sucesso!')
                this.$emit('close-dialog', false)
            }).catch((error) => {
                this.processing = false
                showError('Erro ao atribuir executivo. Tente novamente.')
            })

        }
    }
}
</script>
<style scoped lang="scss">
.--radio-boxes{
    .v-radio{
        padding: 10px;
        border: 1px solid #dadada;
        border-radius: 3px;
        margin-bottom: 8px;
        &.v-item--active{
            border-color: #203a75;
        }
        &.-success{
            color: #4caf50;
            border-color: #4caf50;
        }
    }
    .--radio-label{
        width: 100%;
        display: grid;
        grid-template-columns: 4fr 4fr 2fr;
    }
}
</style>